export default __webpack_public_path__ + "static/media/metamask_steps_7.cf260c5f.png";